import './_editorial-block.scss';

export default () => {};
